<template>
  <div
    :data-cy="`session-${session.id}`"
    class="flex flex-row items-center space-x-4 rounded-sm p-2"
    :class="{ 'bg-label/10': isActive }"
    @click="emit('session:click')"
    @mouseover="emit('session:hover')"
  >
    <div class="h-4 w-4">
      <icon-base :icon="IconMessage" class="text-label" />
    </div>
    <div class="flex w-full flex-col">
      <div class="flex items-center justify-start space-x-2">
        <div
          v-if="session.first_message?.message"
          class="max-w-3/5 truncate text-headline"
        >
          {{ session.first_message.message }}
        </div>
        <lf-tag v-if="session.application_id" size="xs">
          {{ session.application_id?.toString()?.slice(0, 7) }}&hellip;
        </lf-tag>
      </div>
      <div class="flex items-center justify-start space-x-2 text-xs">
        <lf-tag
          v-if="session.application_name"
          size="xs"
          class="max-w-3/5 truncate text-headline capitalize"
        >
          {{ session.application_name }}
        </lf-tag>
        <span>
          {{ $t("LOGS.CREATED") }}:
          {{ formatDateCustom(session.created_at) }}
        </span>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { formatDateCustom } from "@/helpers/formatting";

import IconMessage from "@/components/icons/IconMessage.vue";
import IconBase from "@/components/ui/IconBase.vue";
import LfTag from "@/components/ui/text/LfTag.vue";

import type { AiAgentSession } from "@/models/aiAgents";

const { session, isActive = false } = defineProps<{
  session: AiAgentSession;
  isActive?: boolean;
}>();

const emit = defineEmits<{
  "session:hover": [];
  "session:click": [];
}>();
</script>
